/**
 * 日程調整ツールのAPIクライアント。
 *
 * 接続先は既存の第1世代 `functions`（メール・カレンダーと同じ関数）。
 * ローカル検証では .env.development.local の REACT_APP_FUNCTIONS_DOMAIN で
 * エミュレータに向けられる。
 */
export const bookingApiBase =
  process.env.REACT_APP_FUNCTIONS_DOMAIN ||
  "https://asia-northeast1-non-apo.cloudfunctions.net/functions";

/**
 * 期間内の空き枠を取る。
 * @returns {Promise<{ok: boolean, error?: string, data?: object}>}
 */
export const fetchAvailability = async ({ slug, from, to }) => {
  try {
    const params = new URLSearchParams({ slug, from, to });
    const response = await fetch(
      `${bookingApiBase}/booking/availability?${params}`
    );
    const data = await response.json();
    if (!response.ok || !data.success) {
      return { ok: false, error: data.error ?? "空き枠を取得できませんでした" };
    }
    return { ok: true, data };
  } catch (error) {
    console.log(error);
    return { ok: false, error: "通信に失敗しました" };
  }
};

/**
 * 予約を確定する。
 * 枠はサーバ側でもう一度確認されるため、埋まっていれば 409 が返る。
 */
export const createBooking = async (payload) => {
  try {
    const response = await fetch(`${bookingApiBase}/booking/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      return {
        ok: false,
        // 枠が埋まった場合は呼び出し側で空き枠を取り直す
        conflict: response.status === 409,
        error: data.error ?? "予約を登録できませんでした",
      };
    }
    return { ok: true };
  } catch (error) {
    console.log(error);
    return { ok: false, error: "通信に失敗しました" };
  }
};
